import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Paper from "@material-ui/core/Paper";
import ListItemText from "@material-ui/core/ListItemText";
import AppBar from "@material-ui/core/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import Grid from "@material-ui/core/Grid";
import {TimeUtil} from "../utils/TimeUtil";
import {BASE_URL_API} from "../Const";
import {BackButton,FormPropsTextFields} from './HookUtils'

export class TransactionComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            transactionList: [],
        }
    }

    componentDidMount() {
        fetch(BASE_URL_API+ 'transaction', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {

                    if (results.code === 200) {
                        console.log("ok")
                        this.setState({transactionList: results.data})
                    }

                },
                (error) => {
                    console.log("error")
                }
            );
    }

    render() {

        return (
            <React.Fragment>
                <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                    <ToolbarMui>

                        <PendingActionsOutlinedIcon/>


                        <ListItemText align="center"><strong style={{
                            fontSize: 18,
                            overflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            color: 'black'
                        }} >{"سوابق تراکنش"}</strong></ListItemText>

                        <BackButton/>
                    </ToolbarMui>

                </AppBar>

                <List style={{marginTop: 70}}> {this.state.transactionList.map((item) => (

                    <ListItem style={{justifyContent: 'center',
                        alignItems: 'center'}}>
                        <div  style={{maxWidth: 400}}>
                            <Paper  style={{width:'100%'}}>
                                <ListItemText style={{align: 'right'}}>
                                    <Grid container>
                                        <Grid item xs={8}>
                                            <p style={{ marginRight:12,overflow: 'ellipsis', whiteSpace: 'nowrap', color: 'green'}}
                                               align='right'>{"وضعیت: "}
                                                {item.status === "completed" ? "موفق" : ""}
                                                {item.status === "failed" ? "ناموفق" : ""}
                                                {item.status === "pending" ? "در انتظار پرداخت" : ""}
                                            </p>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <p style={{overflow: 'ellipsis', whiteSpace: 'nowrap',color:'gray'}}
                                               align='center'>{TimeUtil.gregorianToJalali(item.created_at)}</p>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <p style={{marginRight:12,overflow: 'ellipsis', whiteSpace: 'nowrap', color: 'green'}}
                                               align='left'>{"قیمت: " + item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " تومان"}</p>
                                        </Grid>
                                        <Grid item xs={12} >
                                            <p
                                               align='center'>{"شناسه پرداخت: " + item.authority}</p>
                                        </Grid>


                                    </Grid>


                                </ListItemText>

                            </Paper>

                        </div>

                    </ListItem>

                ))
                }
                </List>

                <FormPropsTextFields/>
            </React.Fragment>


        );

    }

}
